import { Button, Group, Tooltip } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import React from "react";

const CreateNewButton: React.FC<{
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  tooltip?: string;
  size?: string;
  outline?: boolean;
}> = ({ onClick, label, disabled, tooltip, size = "md", outline = false }) => {
  // Map legacy size to Mantine sizes (keep defaults if unexpected)
  const sizeMap: Record<string, string> = { xs: "xxs", sm: "xs", md: "sm", lg: "md" };
  const mantineSize = sizeMap[size] ?? "sm";

  const content = (
    <Button
      px={mantineSize}
      variant={outline ? "light" : "filled"}
      size={size}
      onClick={onClick}
      disabled={disabled}
      flex="none"
      {...(size === "xs" ? { style: { width: "2em", minWidth: "2em", height: "1.5em" } } : {})} // custom size for xs
    >
      <Group gap="xs" align="center" justify="center">
        <IconPlus size={size === "xs" ? 14 : 16} stroke={4} />
        {label}
      </Group>
    </Button>
  );

  if (tooltip) {
    return (
      <Tooltip withArrow label={tooltip} offset={2} openDelay={200}>
        {content}
      </Tooltip>
    );
  }
  return content;
};

export default CreateNewButton;
